export default "__VITE_ASSET__CGzr$nal__"